import Loading from "@/pages/loading";
import { DashboardRoutes } from "@/router";
import { useAppDispatch, useAppSelector } from "@/utils";
import { ActivationSteps } from "@payping/api/app/api/bnplMerchantTypes";
import { bnplMerchantGetOptions } from "@payping/redux/actions";
import { useMessagedAsync } from "@payping/web-components";
import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";

const BnplPlansLayout: React.FC<PropsWithChildren> = (props) => {
  const dispatch = useAppDispatch();

  const contract = useAppSelector((state) => state.bnplMerchant.contract);

  const getOptions = useMessagedAsync(() => dispatch(bnplMerchantGetOptions()), [], { error: true, success: false });

  if (getOptions.loading || getOptions.error?.name === "AuthError") {
    return <Loading />;
  }
  if (
    !(
      contract?.next === ActivationSteps.NoNext ||
      contract?.next === ActivationSteps.SignContract ||
      contract?.next === ActivationSteps.WaitingForAdmin
    )
  ) {
    return <Navigate to={DashboardRoutes.myShop.bnpl.activation.root.url} />;
  }
  if (getOptions.error) {
    return <Navigate to={DashboardRoutes.home.root.url} />;
  }

  return <>{props.children}</>;
};

export default BnplPlansLayout;
